import { BaseWidgetRenderer } from './base-widget-renderer';
import { SignInWidgetJsonData, WidgetRenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';

export class SignInWidgetRenderer extends BaseWidgetRenderer<SignInWidgetJsonData> {
    protected override get defaultData(): SignInWidgetJsonData {
        return {
            id: '',
            type: 'signin',
            content: TranslateUtils.SIGN_IN_WIDGET.TEXT
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderContent(widgetJsonData: SignInWidgetJsonData, options: WidgetRenderOptions): HTMLElement {
        const content = document.createElement('div');
        content.classList.add('element-content');

        const textElement = document.createElement('div');
        textElement.dataset['inlineInject'] = '';
        textElement.classList.add('ck-content');

        if (widgetJsonData.content) {
            textElement.innerHTML = widgetJsonData.content;
        }

        content.appendChild(textElement);
        return content;
    }
}
